export const BILLING_ZIP_CODE_COOKIE = 'billing_zip_code';
export const ZIP_CODE_COOKIE = 'zip_code';
export const AUTH_COOKIE = '.AspNet.Cookies';
export const CART_ID_COOKIE = '_msdyn365___cart_';
export const USE_BED_HUB_COOKIE = 'USE_BED_HUB';
export const CHECKOUT_CART_ID_COOKIE = '_msdyn365___checkout_cart_';
export const SYF_DETAILS = 'syf_details';
export const CART_MERGE_SKIP = 'bypass_cart_merge';
export const USE_DEBUG_COOKIE = 'USE_DEBUG';
export const PAYMENT_TYPE_LOCALSTORAGE_KEY = 'payment_type';

export const CART_COOKIE_EXPIRATION_DAYS = 7;
export const FORTER_TOKEN = 'forterToken';
export const FORTER_TOKEN_LOCALSTORAGE_KEY = 'forter_token';

export const requiredCookies = [
  ZIP_CODE_COOKIE,
  AUTH_COOKIE,
  CART_ID_COOKIE,
  USE_BED_HUB_COOKIE,
  CHECKOUT_CART_ID_COOKIE,
  SYF_DETAILS,
  CART_MERGE_SKIP,
  USE_DEBUG_COOKIE,
  PAYMENT_TYPE_LOCALSTORAGE_KEY,
];
